/**
 * UK FCA Financial Promotion Order — Prescribed Statements (31 Jan 2024).
 *
 * IMPORTANT: This text is the public statutory wording from the FPO 2005,
 * as amended by the Financial Promotion (Amendment and Self-Certified
 * Sophisticated Investor) Order 2024. It must be presented verbatim to the
 * investor before they sign.
 *
 * Sources:
 *  - https://www.legislation.gov.uk/uksi/2005/1529 (FPO 2005)
 *  - The Financial Services and Markets Act 2000 (Financial Promotion)
 *    (Amendment) Order 2023 — which brought in the new thresholds and wording.
 *
 * Do not modify the statement text without legal review.
 */

export const HNWI_STATEMENT = `HIGH NET WORTH INVESTOR STATEMENT

I make this statement so that I can receive promotional communications which are exempt from the restriction on promotion of non-readily realisable securities. The exemption relates to certified high net worth investors and I declare that I qualify as such because at least one of the following applies to me:

(a) I had, during the financial year immediately preceding the date below, an annual income to the value of £170,000 or more. Annual income for these purposes does not include money drawn down from pensions (whether in the form of lump sums or regular payments).

(b) I held, throughout the financial year immediately preceding the date below, net assets to the value of £430,000 or more. Net assets for these purposes do not include:
  (i) the property which is my primary residence or any money raised through a loan secured on that property;
  (ii) any rights of mine under a qualifying contract of insurance; or
  (iii) any benefits (in the form of pensions or otherwise) which are payable on the termination of my service or on my death or retirement and to which I am (or my dependants are), or may be, entitled.

I accept that the investments to which the promotions I receive may relate are likely to expose me to a significant risk of losing all of the property invested. I am aware that it is open to me to seek advice from someone who specialises in advising on this kind of investment.

I declare that I have answered yes to A and/or B, and wish to be treated as a high net worth individual.`;


export const SOPHISTICATED_STATEMENT = `SELF-CERTIFIED SOPHISTICATED INVESTOR STATEMENT

I declare that I am a self-certified sophisticated investor for the purposes of the restriction on promotion of non-readily realisable securities. I understand that this means:

(i) I can receive promotional communications made by a person who is authorised by the Financial Conduct Authority, by an exempt person or by any other person which relate to investment activity in non-readily realisable securities;

(ii) the investments to which the promotions will relate may expose me to a significant risk of losing all of the money or other property invested.

I am a self-certified sophisticated investor because at least one of the following applies:

(a) I am a member of a network or syndicate of business angels and have been so for at least the last six months prior to the date below;

(b) I have made more than one investment in an unlisted company in the two years prior to the date below;

(c) I am working, or have worked in the two years prior to the date below, in a professional capacity in the private equity sector, or in the provision of finance for small and medium enterprises;

(d) I am currently, or have been in the two years prior to the date below, a director of a company with an annual turnover of at least £1.6 million.

I accept that the investments to which the promotions I receive may relate are likely to expose me to a significant risk of losing all of the property invested. I am aware that it is open to me to seek advice from someone who specialises in advising on this kind of investment.`;


export const STATEMENT_VERSION = 'FCA-FPO-2024-01-31';
